module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADmSURBVDhPYzRTvvufgQLAqKO6ypXrn/Gub0xn3aBiRAEUPeS4AqaHCcwjAPRVV2boyi0VhHJRAEEDQDax/zOZzsDGWgAVQgFYDdBTWZWpp7xCh4GhAS7P+d+4TklpFT+UCwcYBoBs5PhvPI2DwfSyvormHJDYqbvKYHW8TAz5IBoZoBigojKJHUR/ZzwdA6LZ/5skfv99QhnIBAcY+3/jRm3RVTwgNgpAxEIDk47yqkAIm4FBSmomF5QJBtoqq7SgTNSYQ+EQCWB6KE6JWGOBagDkOkIuZITSGABdIzAqsaql0AsMDABohkdx8/4ybQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/dzy/assets/img/fk_zs.png
// module id = yikn
// module chunks = 43